
function initSubjectWidth() {
	let odPro = $('.odPro').innerWidth();
	$('.vec').find('input').css('width', odPro);
}

export function changeMailAttribute(mode, iconId, iconOn, mailId, option) {
	const iconElm = iconId.length > 0 ? $("#" + iconId) : null;
	let newFolder = 0;
	let flag = '';
	if (mode === "folder") {
		newFolder = $("#" + option).val();
	} else if (mode === "task") {
		if (iconElm.hasClass("state-icon-on")) {
			flag = iconElm.attr("data-icon") === "task" ? "on" : "off";
		} else flag = "off";
	} else {
		flag = iconElm.hasClass("state-icon-on") ? "on" : "off";
	}
	let dataString = 'mailId=' + mailId + '&flag=' + flag + '&mode=' + mode + '&folder=' + newFolder;


	$.ajax({
		type: "POST",
		url: "./ajax/updateMailFlags.jsp",
		contentType: "application/x-www-form-urlencoded;charset=UTF-8",
		data: dataString,
		success: function (output) {
			let obj;
			obj = jQuery.parseJSON(output);
			if (mode !== "folder") {
				iconElm.html(Icon.entity(obj.iconLink));
				iconElm.attr("data-icon", obj.iconLink);
				if (obj.state) iconElm.addClass("state-icon-on");
				else iconElm.removeClass("state-icon-on");
				iconElm.hide().fadeIn(400);
				iconElm.attr("title", obj.title);

				if (mode === "spam") {
					$("#" + option).val(obj.folder);
				}
				else if (mode === "task" && obj.completeUpdate === "true") {
					$("#responsible").val(obj.responsible);
					setDateTimePicker("complete", new Date().getTime(), true);
				}
			}
		},
		error: function (err) {
			console.log("error:" + err.status + " | " + err.statusText)
		}
	});
	return false;
}

window.changeMailAttribute = changeMailAttribute;

export function updateMailReferenceIcons() {
	const container = $("#mail-references");
	const op = parseInt($("input[name=opportunity]").val());
	const bc = parseInt($("input[name=busCase]").val());
	const cp = parseInt($("input[name=campaign]").val());
	const pr = parseInt($("input[name=problem]").val());
	container.empty();
	appendReference(container, op, "opportunity", "editOpportunity.do?id=", "opportunityName");
	appendReference(container, bc, "case", "editBusCaseLow.do?id=", "busCaseName");
	appendReference(container, cp, "campaign", "editCampaign.do?id=", "campaignSymbol");
	appendReference(container, pr, "flash", "editProblem.do?id=", "problemFileAs");
}

function appendReference(container, id, iconName, editUrl, nameInputId) {
	if (id === 0) return;
	const ln = $("<a class='ref-link'></a>");
	ln.attr("href", editUrl + id);
	ln.append(Icon.fi(iconName, "ref-icon"));
	if (nameInputId) {
		const ipt = $("#"+nameInputId);
		const name = ipt.val();
		if (name) {
			ln.attr("title", name);
		}
	}
	container.append(ln);
}
